import { EFinancingProgram, ELanguage, ELoanPurpose } from '@if/core/types'
import * as yup from '@if/core/yup'

export enum ECommunicationType {
  Email = 'email',
  SMS = 'sms',
  Both = 'both',
}

export const invitationSchema = yup.object({
  firstName: yup.string().max(50).required(),
  lastName: yup.string().max(50).required(),
  languageId: yup
    .mixed<ELanguage>()
    .oneOf(Object.values(ELanguage).filter((value) => typeof value === 'number'))
    .required()
    .default(ELanguage.English),
  communicationType: yup.string().oneOf(Object.values(ECommunicationType)).required().default(ECommunicationType.Both),
  email: yup.string().when('communicationType', {
    is: (val: ECommunicationType) => val === ECommunicationType.Email || val === ECommunicationType.Both,
    then: (schema) => schema.email().max(60).required('Email is required when email communication is selected'),
    otherwise: (schema) => schema.notRequired(),
  }),
  mobilePhoneNumber: yup.string().when('communicationType', {
    is: (val: ECommunicationType) => val === ECommunicationType.SMS || val === ECommunicationType.Both,
    then: (schema) =>
      schema.validCanadianPhone().required('Phone number is required when SMS communication is selected'),
    otherwise: (schema) => schema.notRequired(),
  }),
  confirmationChecked: yup.boolean().oneOf([true], 'You must confirm to proceed').required(),
  financingProgramId: yup
    .string()
    .oneOf(Object.values(EFinancingProgram))
    .required()
    .default(EFinancingProgram.MechanicalWarranty),
  serviceCategory: yup.string().oneOf(Object.values(ELoanPurpose)).optional(),
})

export type InvitationFormData = yup.InferType<typeof invitationSchema>
